module.exports = __webpack_public_path__ + "5ae835072e4f54ee188c2c4babd1367a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/motorcycle-jacket-s.png
// module id = 1876
// module chunks = 0